















































































import {
  defineComponent,
  ref,
  computed,
  PropType,
} from '@vue/composition-api';
import type { ContractListItem, ProductItemType } from '@/api/rights/shop-mall/types';
import { formatContractName, getContractIframeUrl } from '@/views_v2/pre-apply-choose/utils';
import { Tabs, TabItem, Checkbox } from '@hb/coffee';
import type { Commodity } from '@/api/contract/types';
import { newUbtPageButton, shopMallAgreementClick } from '../tianqi';
import CreditPaymentAgreement from './credit-payment-agreement.vue';

export default defineComponent({
  name: 'UnitAgreementControlGroup',
  components: {
    Tabs,
    TabItem,
    Checkbox,
    CreditPaymentAgreement,
  },
  props: {
    contractList: {
      type: Array as PropType<ContractListItem[]>,
      required: true,
    },
    /** 产品列表 */
    productList: {
      type: Array as PropType<ProductItemType[]>,
      required: true,
    },
    dcCommodityList: {
      type: Array as PropType<Commodity[]>,
      required: true,
    },
    from: {
      type: String,
      required: true,
    },
    applyMode: {
      type: String,
      default: '',
    },
  },
  setup(props: {
    contractList: ContractListItem[];
    dcCommodityList: Commodity[];
    from: string;
    applyMode: string;
  }) {
    /** 分期商城协议当前下标 */
    const fqMallContractIndex = ref(0);
    /** 贷超半流程协议机构产品当前下标 */
    const dcProductIndex = ref(0);
    /** 贷超半流程协议当前下标 */
    const dcContractIndex = ref(0);

    /** 是否选中贷超半流程协议 */
    const isCheckboxChecked = ref(false);

    /** 当前贷超半流程协议列表 */
    const currentDcContractList = computed(() => (
      props.dcCommodityList[dcProductIndex.value]?.contractList || []
    ));

    /** 贷超半流程协议URL */
    const dcContractUrl = computed(() => {
      const product = props.dcCommodityList[dcProductIndex.value];
      const contract = currentDcContractList.value[dcContractIndex.value];
      return getContractIframeUrl(
        Number(product.productId),
        contract.url,
      );
    });

    /** 切换勾选框 */
    const changeCheckbox = () => {
      isCheckboxChecked.value = !isCheckboxChecked.value;

      if (isCheckboxChecked.value) {
        newUbtPageButton(shopMallAgreementClick, {
          buttonName: '勾选贷超协议',
          from: props.from,
          applyMode: props.applyMode,
        });
      }
    };

    /** 切换机构产品 */
    const changeDcProductIndex = (index: number) => {
      dcContractIndex.value = 0; // 切换产品时重置协议下标
      dcProductIndex.value = index;
    };

    /** 切换贷超半流程协议 */
    const changeDcContractIndex = (index: number) => {
      dcContractIndex.value = index;
    };

    return {
      dcProductIndex,
      dcContractIndex,
      currentDcContractList,
      dcContractUrl,
      isCheckboxChecked,
      changeDcProductIndex,
      changeDcContractIndex,
      formatContractName,
      changeCheckbox,
    };
  },
});
